import React, { useRef, useState, useEffect } from "react";
import { IconButton, makeStyles } from "@material-ui/core";
import { PlayArrow, Pause, HeadsetMic, Mic } from "@material-ui/icons";

const LS_NAME = "audioMessageRate";

const useStyles = makeStyles((theme) => ({
  player: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    minWidth: 230,
    maxWidth: 300,
    // folga a direita para nao colidir com a setinha de acoes (ExpandMore)
    // nem com o timestamp do balao.
    padding: "4px 34px 4px 0",
  },
  avatar: {
    position: "relative",
    width: 46,
    height: 46,
    borderRadius: "50%",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  avatarFile: {
    backgroundColor: "#ff8c1a",
  },
  avatarVoice: {
    backgroundColor: "#cfd8dc",
  },
  avatarImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  avatarIcon: {
    color: "#fff",
    fontSize: 24,
  },
  micBadge: {
    position: "absolute",
    right: -1,
    bottom: -1,
    fontSize: 16,
    color: "#25d366",
    backgroundColor: "#fff",
    borderRadius: "50%",
    padding: 1,
  },
  playBtn: {
    padding: 6,
    color: "#54656f",
  },
  seek: {
    flex: 1,
    minWidth: 0,
    height: 4,
    margin: 0,
    cursor: "pointer",
    accentColor: "#25d366",
  },
  time: {
    fontSize: 11,
    color: "#667781",
    flexShrink: 0,
    minWidth: 30,
    textAlign: "center",
  },
  rateBtn: {
    fontSize: 11,
    fontWeight: 600,
    color: "#fff",
    backgroundColor: "#8696a0",
    border: "none",
    borderRadius: 10,
    padding: "1px 7px",
    cursor: "pointer",
  },
}));

const formatTime = (seconds) => {
  if (!seconds || Number.isNaN(seconds) || !Number.isFinite(seconds)) {
    return "0:00";
  }
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
};

export default function Audio({ url, message }) {
  const classes = useStyles();
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [current, setCurrent] = useState(0);
  const [duration, setDuration] = useState(0);
  const [rate, setRate] = useState(
    parseFloat(localStorage.getItem(LS_NAME) || "1")
  );

  const isVoice = message?.mediaType === "ptt";
  const avatarUrl = String(message?.contact?.profilePicUrl || "").trim();

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.playbackRate = rate;
      localStorage.setItem(LS_NAME, rate);
    }
  }, [rate, playing]);

  const onLoaded = () => {
    const d = audioRef.current?.duration;
    if (d && Number.isFinite(d)) setDuration(d);
  };
  const onTime = () => setCurrent(audioRef.current?.currentTime || 0);
  const onEnded = () => {
    setPlaying(false);
    setCurrent(0);
  };

  const toggle = () => {
    const el = audioRef.current;
    if (!el) return;
    if (playing) {
      el.pause();
      setPlaying(false);
    } else {
      el.play();
      setPlaying(true);
    }
  };

  const seek = (e) => {
    const value = Number(e.target.value);
    if (audioRef.current) audioRef.current.currentTime = value;
    setCurrent(value);
  };

  const cycleRate = () => {
    const next = { 0.5: 1, 1: 1.5, 1.5: 2, 2: 0.5 }[rate] || 1;
    setRate(next);
  };

  return (
    <div className={classes.player}>
      <div
        className={`${classes.avatar} ${
          isVoice ? classes.avatarVoice : classes.avatarFile
        }`}
      >
        {isVoice && avatarUrl ? (
          <img className={classes.avatarImg} src={avatarUrl} alt="" />
        ) : (
          <HeadsetMic className={classes.avatarIcon} />
        )}
        {isVoice && <Mic className={classes.micBadge} />}
      </div>

      <IconButton className={classes.playBtn} size="small" onClick={toggle}>
        {playing ? <Pause /> : <PlayArrow />}
      </IconButton>

      <span className={classes.time}>
        {formatTime(playing || current ? current : duration)}
      </span>

      <input
        className={classes.seek}
        type="range"
        min={0}
        max={duration || 0}
        step="any"
        value={current}
        onChange={seek}
      />

      {playing && (
        <button className={classes.rateBtn} onClick={cycleRate}>
          {rate}x
        </button>
      )}

      <audio
        ref={audioRef}
        src={url}
        preload="metadata"
        onLoadedMetadata={onLoaded}
        onTimeUpdate={onTime}
        onEnded={onEnded}
        style={{ display: "none" }}
      />
    </div>
  );
}
